import React from 'react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-[100] px-5 sm:px-6 md:px-[48px] py-[22px] flex items-center justify-between bg-[rgba(7,7,7,0.55)] backdrop-blur-[20px] backdrop-saturate-150 border-b border-tux-border" data-id="element-109">
      <a href="#" className="font-display font-black text-[18px] uppercase tracking-[0.02em] text-white flex items-baseline no-underline" data-id="element-110">
        <span data-id="element-111">VAULT</span>
        <span className="font-mono font-light text-tux-lime text-[0.88em] mx-[0.04em]" data-id="element-112">
          [
        </span>
        <span data-id="element-113">LAB</span>
        <span className="font-mono font-light text-tux-lime text-[0.88em] mx-[0.04em]" data-id="element-114">
          ]
        </span>
      </a>

      <div className="hidden md:flex items-center gap-8" data-id="element-115">
        <a href="#what" className="font-mono text-[10px] tracking-[0.22em] text-tux-muted uppercase no-underline transition-colors duration-150 hover:text-white" data-id="element-116">
          Work
        </a>
        <a href="#culture" className="font-mono text-[10px] tracking-[0.22em] text-tux-muted uppercase no-underline transition-colors duration-150 hover:text-white" data-id="element-117">
          About
        </a>
        <a href="#footer" className="font-mono text-[10px] tracking-[0.22em] text-tux-muted uppercase no-underline transition-colors duration-150 hover:text-white" data-id="element-118">
          Contact
        </a>
        <a href="mailto:hello@vaultlab.agency" className="font-mono text-[10px] tracking-[0.22em] text-tux-lime uppercase no-underline border border-[rgba(200,255,0,0.3)] px-[18px] py-[8px] transition-colors duration-150 hover:bg-[rgba(200,255,0,0.06)]" data-id="element-119">
          Brief Us
        </a>
      </div>
    </nav>;
}